import { ViewportScroller } from '@angular/common';
import {
    ViewEncapsulation,
    Component,
    ElementRef,
    input,
    inject,
    ChangeDetectionStrategy,
    OnInit,
} from '@angular/core';
import { SizeRange } from '@bazis/shared/models/base.types';
import { fromEvent, throttleTime } from 'rxjs';
import { map, startWith } from 'rxjs/operators';

const sharedStylesheet = new CSSStyleSheet();
sharedStylesheet.replaceSync(
    `:host { --bottom: 0; --margin-end: 0; --margin-start: 0; display: flex; justify-content: flex-end; position: sticky; bottom: var(--bottom); z-index: 150; pointer-events: none; height: 0; margin-right: var(--margin-end); margin-left: var(--margin-start); } :host bazis-button { pointer-events: all; } :host(.bazis-color) bazis-button.bazis-btn_solid::part(native) { --background: var(--bazis-color-base); --background-hover: var(--bazis-color-shade); --background-activated: var(--bazis-color-tint); --color: var(--bazis-color-contrast); --color-rgb: var(--bazis-color-contrast-rgb); --color-hover: var(--bazis-color-contrast); --color-focused: var(--bazis-color-contrast); --color-activated: var(--bazis-color-contrast); } :host(.bazis-color) bazis-button.bazis-btn_outline::part(native) { --color: var(--bazis-color-base); --color-rgb: var(--bazis-color-base-rgb); --color-hover: rgba(var(--bazis-color-shade-rgb), 0.8); --color-focused: rgba(var(--bazis-color-base-rgb), 0.8); --color-activated: var(--bazis-color-base); } :host(.bazis-color) bazis-button.bazis-btn_clear::part(native) { --color: var(--bazis-color-base); --color-rgb: var(--bazis-color-base-rgb); --color-hover: var(--bazis-color-shade); --color-focused: var(--bazis-color-shade); --color-activated: var(--bazis-color-tint); }`,
);

@Component({
    selector: 'bazis-totop',
    templateUrl: './totop.component.html',
    // styleUrls: ['totop.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    encapsulation: ViewEncapsulation.ShadowDom,
    standalone: false,
})
export class TotopElement implements OnInit {
    public el = inject(ElementRef);

    public viewportScroller = inject(ViewportScroller);

    readonly sizeBtn = input<SizeRange>(SizeRange.large);

    readonly icon = input<string>('arrow-up');

    readonly sizeIcon = input<SizeRange>(SizeRange.huge);

    readonly treshhold = input<number>(300);

    windowScrollTopPosition$ = fromEvent(window, 'scroll').pipe(
        startWith(0),
        throttleTime(100),
        map((v) => this.viewportScroller.getScrollPosition()[1]),
    );

    ngOnInit(): void {
        const host = this.el.nativeElement;
        if (host && host.shadowRoot) {
            const shadowRoot = host.shadowRoot;
            const styles = shadowRoot.querySelectorAll('style');
            styles.forEach((style) => style.remove());
            shadowRoot.adoptedStyleSheets = [sharedStylesheet];
        }
    }

    scrollToTop() {
        window.scrollTo({ top: 0 });
    }
}
